import { MissionAcceptanceType } from '@enums/mission-acceptance-type.enum';
import { HttpHelper } from '@helpers/http.helper';

export interface MissionAcceptanceInformationsJson {
  id: number;
  type: MissionAcceptanceType;
  monthly_billed_plan: number;
  ca_forecast_amount: number;
  activity_comment: string;
  previous_accountant_contacted: boolean;
  previous_accountant_letter_date: string;
  previous_accountant_opposition_existed: boolean;
  directors_owners_stranger_companies: boolean;
  directors_french_residents: boolean;
  directors_owners_liquidation_companies: boolean;
  directors_owners_other_accountant_companies: boolean;
}

export class MissionAcceptanceInformations {
  constructor(
    public id?: number,
    public type?: MissionAcceptanceType,
    public monthlyBilledPlan?: number,
    public caForecastAmount?: number,
    public activityComment?: string,
    public previousAccountantContacted?: boolean,
    public previousAccountantLetterDate?: string,
    public previousAccountantOppositionExisted?: boolean,
    public directorsOwnersStrangerCompanies?: boolean,
    public directorsFrenchResidents?: boolean,
    public directorsOwnersLiquidationCompanies?: boolean,
    public directorsOwnersOtherAccountantCompanies?: boolean
  ) {}

  static fromJson(json: Partial<MissionAcceptanceInformationsJson>): MissionAcceptanceInformations {
    return new MissionAcceptanceInformations(
      json.id,
      json.type,
      json.monthly_billed_plan,
      json.ca_forecast_amount,
      json.activity_comment,
      json.previous_accountant_contacted,
      json.previous_accountant_letter_date,
      json.previous_accountant_opposition_existed,
      json.directors_owners_stranger_companies,
      json.directors_french_residents,
      json.directors_owners_liquidation_companies,
      json.directors_owners_other_accountant_companies
    );
  }

  static toJson(missionAcceptanceInformations: MissionAcceptanceInformations): MissionAcceptanceInformationsJson {
    return {
      id: HttpHelper.toJsonProperty(missionAcceptanceInformations.id),
      type: HttpHelper.toJsonProperty(missionAcceptanceInformations.type),
      monthly_billed_plan: HttpHelper.toJsonProperty(missionAcceptanceInformations.monthlyBilledPlan),
      ca_forecast_amount: HttpHelper.toJsonProperty(missionAcceptanceInformations.caForecastAmount),
      activity_comment: HttpHelper.toJsonProperty(missionAcceptanceInformations.activityComment),
      previous_accountant_contacted: HttpHelper.toJsonProperty(
        missionAcceptanceInformations.previousAccountantContacted
      ),
      previous_accountant_letter_date: HttpHelper.toJsonProperty(
        missionAcceptanceInformations.previousAccountantLetterDate
      ),
      previous_accountant_opposition_existed: HttpHelper.toJsonProperty(
        missionAcceptanceInformations.previousAccountantOppositionExisted
      ),
      directors_owners_stranger_companies: HttpHelper.toJsonProperty(
        missionAcceptanceInformations.directorsOwnersStrangerCompanies
      ),
      directors_french_residents: HttpHelper.toJsonProperty(missionAcceptanceInformations.directorsFrenchResidents),
      directors_owners_liquidation_companies: HttpHelper.toJsonProperty(
        missionAcceptanceInformations.directorsOwnersLiquidationCompanies
      ),
      directors_owners_other_accountant_companies: HttpHelper.toJsonProperty(
        missionAcceptanceInformations.directorsOwnersOtherAccountantCompanies
      )
    };
  }
}
